"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
var ViewType;
(function (ViewType) {
    ViewType[ViewType["Fullscreen"] = 0] = "Fullscreen";
    ViewType[ViewType["Overlay"] = 1] = "Overlay";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var AnimationType;
(function (AnimationType) {
    AnimationType["None"] = "none";
    AnimationType["Fade"] = "fade";
    AnimationType["FadeOut"] = "fadeOut";
    AnimationType["Left"] = "left";
    AnimationType["LeftOut"] = "leftOut";
    AnimationType["Slide"] = "slide";
    AnimationType["SlideOut"] = "slideOut";
})(AnimationType = exports.AnimationType || (exports.AnimationType = {}));
exports.defaultSlideAnimation = { type: AnimationType.Slide, duration: 0.2 };
exports.defaultFadeAnimation = { type: AnimationType.Fade, duration: 0.5 };
exports.defaultStackViewProperties = {
    type: ViewType.Fullscreen,
    animation: { type: AnimationType.None, duration: 0 },
};
// tslint:disable-next-line:no-empty
const noop = () => { };
const context = React.createContext({
    animating: false,
    views: [],
    push: noop,
    pop: noop,
    pushRoot: noop,
    popRoot: noop,
    pushParent: noop,
    popParent: noop,
});
exports.StackNavigationContextProvider = context.Provider;
exports.StackNavigationContextConsumer = context.Consumer;
